export const getDateIsoStringWithoutSecondsAndMilliseconds = (date: Date) =>
  new Date(date.setSeconds(0, 0)).toISOString();
